import type {
	Components,
} from '@mui/material'

export const materialUISelectTheme: {
	components: Components
} = {
	components: {
		MuiSelect: {
			styleOverrides: {
				root:   {
					borderRadius: 'var(--border-radius-xs)',
					transition:   'background-color 0.2s ease 0s',

					backgroundColor: 'var(--surface-container-color)',

					':hover': {
						backgroundColor: 'var(--gray-color-100)',
					},

					':after, :before': {
						display: 'none',
					},
				},
				select: {
					display:    'flex',
					alignItems: 'center',
					fontSize:   'var(--font-size-body-x-small)',
					color:      'var(--on-surface-color)',

					padding:   'var(--base-spacing-2) var(--base-spacing-4)',
					height:    '3rem',
					boxSizing: 'border-box',

					'&.MuiInputBase-inputSizeSmall': {
						height: '2.5rem',
					},
				},
				icon: {
					width:       '1rem',
					height:      '1rem',
					marginRight: '4px',
					color:       'var(--on-surface-color)',
				},

			},
			variants: [
				{
					props: {
						variant: 'outlined',
					},
					style: {

						/* label */
						'& .MuiInputLabel-root': {
							color: 'var(--secondary-color-hint)',
						},
						'& .MuiInputLabel-root.Mui-error': {
							color: 'var(--error-color)',
						},

						/* filled (with value) */

						'&:has(.MuiSelect-nativeInput[value]:not([value=""]))': {
							'.MuiOutlinedInput-notchedOutline': {
								border: '2px solid var(--primary-color)',
							},
						},

						/* root */
						'& .MuiSelect-outlined': {
							backgroundColor: 'var(--surface-container-color)',
						},

						'& .MuiOutlinedInput-notchedOutline': {
							border: 'var(--outline-base)',
						},
						'&:hover .MuiOutlinedInput-notchedOutline': {
							borderColor: 'var(--primary-color)',
						},
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderColor: 'var(--primary-color)',
						},
					},
				},
				{
					props: {
						variant: 'outlined', color: 'secondary',
					},
					style: {

						/* label */
						'& .MuiInputLabel-root': {
							color: 'var(--secondary-color-hint)',
						},
						'& .MuiInputLabel-root.Mui-error': {
							color: 'var(--error-color)',
						},

						/* filled (with value) */

						'&:has(.MuiSelect-nativeInput[value]:not([value=""]))': {
							'.MuiOutlinedInput-notchedOutline': {
								border: 'var(--outline-base)',
							},
						},

						/* root */
						'& .MuiSelect-outlined': {
							backgroundColor: 'var(--surface-color)',
						},

						'& .MuiOutlinedInput-notchedOutline': {
							border: 'var(--outline-base)',
						},
						'&:hover .MuiSelect-outlined': {
							backgroundColor: 'var(--gray-color-200)',
						},
						'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
							borderColor: 'var(--gray-color-200)',
						},
					},
				},
			],
		},
	},
}
